module.exports = __webpack_public_path__ + "img/Celloger Pro.18b2aebe.png";